import { useStoreActions } from '~/contexts';
import { useMutationState } from '../useMutationState';
export const useAcceptServiceDescription = ()=>{
    const { api } = useStoreActions();
    const { mutateAsync, isPending } = useMutationState({
        mutationFn: async (conversationId)=>api.service.acceptServiceDescription(conversationId),
        withPageLoader: false
    });
    return {
        acceptDescription: mutateAsync,
        isLoading: isPending
    };
};
